module.exports = __webpack_public_path__ + "img/hulk_game.ee3b09ab.png";